<template>
  <div class="container_box">
    <!--tab栏-->
    <Tabs v-model="tabName" :animated="false" class="tabs_styles" @on-click="changeTab">
      <TabPane v-for="item in tabList" :label="item.label" :name="item.value"></TabPane>
    </Tabs>
    <!--头部筛选区域-->
    <div class="filter_box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1003913')" :label-width="130">
              <local-tabButton :tabButtonList="costFlowStatusList" @selectStatus="costFlowStatus"></local-tabButton>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <dropDownFilter
              :transfer="false"
              ref="dropDownFilter"
              :selectStyle="{width: '120px'}"
              :dropDownInputList="dropDownInputList"
              :defaultSelectValue="defaultSelectValue"
              @changeInput="changeInput"
              @updateInputValue="updateInputValue">
            </dropDownFilter>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol" v-if="tabName === 'distributor'">
            <FormItem :label="$t('key1001226')" prop="type">
              <Select v-model="pageParams.type">
                <Option v-for="item in expenseTypeList" :value="item.value">{{ item.title }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1003914')">
              <Date-picker
                type="datetimerange"
                class="wid100P"
                @on-clear="resetDate"
                @on-change="getDateValue"
                :clearable="true"
                :options="dateOptions"
                format="yyyy-MM-dd HH:mm:ss"
                placement="bottom-end"
                :placeholder="$t('key1000360')"
                :value="expensesTime">
              </Date-picker>
            </Form-item>
          </Col>
          <Col style="min-width: 200px;" push="1">
            <Button @click="reset" icon="md-refresh" class="mr12">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search" icon="md-search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        highlight-row
        border
        max-height="470"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData">
      </Table>
      <Page
        :transfer="true"
        v-if="!tableLoading"
        :total="total"
        @on-change="changePage"
        show-total
        :page-size="pageParams.pageSize"
        show-elevator
        :current="pageParams.pageNum"
        show-sizer
        @on-page-size-change="changePageSize"
        placement="top"
        :page-size-opts="pageArray">
      </Page>
    </div>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import dropDownFilter from "@/components/common/dropDownFilter";
import {getDataSetBatchList, getEnumList, getEnumName} from "@/utils/common";

export default {
  name: "financialJournal",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      defaultSelectValue: 1,
      expensesTime: [],
      pageParams: {
        createStartTime: null,
        createEndTime: null,
        packageCode: '', // 出库单号
        merchantType: '2', // 1 供应商  2 分销商
        type: 'null', // 费用类型  1 货品费用 2 包裹处理费 3退费
        status: null,
        merchantName: '',
        merchantId: '', // 商户号
        pageNum: 1,
        pageSize: 15
      },
      total: 0,
      tableColumns: [],
      tableData: [],
      tabName: 'distributor',
      tabList: [
        {label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003909'), value: 'distributor'},
        {label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000295'), value: 'supplier'}
      ],
      enumData: [],
      expenseTypeIndex: 0,
      costFlowIndex: 0
    };
  },
  computed: {
    dropDownInputList() {
      let list = [];
      if (this.tabName === 'distributor') {
        list = [
          {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001248'), value: 1, parameterKey: 'packageCode'},
          {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002878'), value: 2, parameterKey: 'merchantName'},
          {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002877'), value: 3, parameterKey: 'merchantId'}
        ];
      } else {
        list = [
          {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003910'), value: 1, parameterKey: 'packageCode'},
          {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001101'), value: 2, parameterKey: 'merchantName'},
          {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001098'), value: 3, parameterKey: 'merchantId'}
        ];
      }
      return list;
    },
    // 费用类型
    expenseTypeList() {
      const ENUM_KEY = 'YmsPackageCostTypeCoreEnum';
      let list = getEnumList(this.enumData, ENUM_KEY, 'number');
      list.unshift({
        value: 'null',
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')
      });
      list = list.filter(item => item.value !== 9);
      list.forEach((item, index) => {
        item.selected = index === this.expenseTypeIndex;
      });
      return list;
    },
    // 费用流水状态
    costFlowStatusList() {
      const ENUM_KEY = this.tabName === 'distributor' ? 'QueryYmsPackageCostBoStatusCoreEnum' : 'QueryYmsPackageCostBoStatusSupplierEnum';
      let list = getEnumList(this.enumData, ENUM_KEY, 'number');
      list.unshift({
        value: null,
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')
      });
      list.forEach((item, index) => {
        item.selected = index === this.costFlowIndex;
      });
      return list;
    },
  },
  created() {
    this.initData();
  },
  methods: {
    // 初始化数据
    async initData() {
      let enumKeyList = [
        'YmsPackageCostTypeCoreEnum',
        'QueryYmsPackageCostBoStatusCoreEnum',
        'QueryYmsPackageCostBoStatusSupplierEnum'
      ];
      this.enumData = await getDataSetBatchList(enumKeyList);
      this.defaultTimePeriodRange(3, 'expensesTime', 'createStartTime', 'createEndTime');
      this.search();
    },
    // 切换tab
    changeTab() {
      this.pageParams.pageNum = 1;
      this.reset();
    },
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.pageParamsStatus = true;
    },
    // 重置按钮
    reset() {
      let v = this;
      v.$refs['pageParams'].resetFields();
      v.expensesTime = [];
      v.changeInput(1);
      v.costFlowStatus(0, null);
      v.defaultTimePeriodRange(3, 'expensesTime', 'createStartTime', 'createEndTime');
      v.getList();
    },
    // 列表查询的方法
    getList() {
      let v = this;
      v.tableData = [];
      v.total = 0;
      if (v.getPermission('ymsPackageCost_query')) {
        let obj = {
          distributor: 2,
          supplier: 1
        };
        v.pageParams.merchantType = obj[v.tabName];
        let params = Object.assign({}, v.pageParams);
        params.type = v.pageParams.type === 'null' ? null : params.type;
        v.tableLoading = true;
        v.axios.post(api.post_ymsPackageCost_query, params).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              let list = data.list || [];
              v.tableData = v.handleMultilinguaTableFields(list, ['merchantName']);
              v.$nextTick(() => {
                v.tableLoading = false;
              });
            }
            v.total = data.total;
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 获取费用产生时间
    getDateValue(value) { // 获取日期返回值
      let v = this;
      if (value.length === 0) {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000356'));
        v.resetDate();
      } else {
        if (!value[0]) {
          v.pageParams.createStartTime = null;
          v.pageParams.createEndTime = null;
        } else {
          let timeList = v.defaultTimePeriod(value);
          v.expensesTime = v.defaultTimePeriod(value, false);
          v.pageParams.createStartTime = v.$uDate.getUniversalTime(new Date(timeList[0]).getTime(), 'fulltime');
          v.pageParams.createEndTime = v.$uDate.getUniversalTime(new Date(timeList[1]).getTime(), 'fulltime');
        }
      }
    },
    // 重置费用产生时间
    resetDate() {
      this.pageParams.createStartTime = null;
      this.pageParams.createEndTime = null;
    },
    // 选取费用流水状态
    costFlowStatus(index, value) {
      this.pageParams.status = value;
      this.costFlowIndex = index;
    },
    // 获取下拉选项筛选条件的值
    updateInputValue(data) {
      this.pageParams[data.key] = data.value;
    },
    // 改变默认下拉选项的值
    changeInput(value) {
      this.defaultSelectValue = value;
      this.$refs.dropDownFilter.inputValue = '';
      this.dropDownInputList.map((item) => {
        if (Object.keys(this.pageParams).includes(item.parameterKey)) {
          this.pageParams[item.parameterKey] = '';
        }
      });
    },
    // 处理列表字段
    handleColumns(name) {
      let v = this;
      v.tableColumns = [];
      let columns = [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003655'),
          key: 'expenseType',
          minWidth: 110,
          align: 'center',
          render: (h, params) => {
            let type = params.row.type;
            let text = getEnumName(v.enumData, 'YmsPackageCostTypeCoreEnum', type, 'number');
            return h('div', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003753'),
          key: 'amount',
          minWidth: 110,
          align: 'center',
          render(h, params) {
            return h('div', [
              h('div', v.formatCurrency(params.row.amount)),
              h('div', '(' + params.row.currency + ')')
            ]);
          }
        },
        {
          title: v.tabName === 'distributor' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001248') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003910'),
          key: 'packageCode',
          align: 'center',
          minWidth: 110,
          render: (h, params) => {
            let packageCode = '';
            v.tabName === 'distributor' ? packageCode = params.row.distributorPackageCode : packageCode = params.row.subPackageCode;
            return h('span', packageCode);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002878'),
          key: 'distributorName',
          minWidth: 150,
          align: 'center',
          render(h, params) {
            let text = params.row.merchantName || '-';
            return h('div', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001101'),
          key: 'supplierName',
          minWidth: 150,
          align: 'center',
          render(h, params) {
            let text = params.row.merchantName || '-';
            return h('div', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002877'),
          key: 'distributorMerchantId',
          minWidth: 110,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001098'),
          key: 'supplierMerchantId',
          minWidth: 110,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003761'),
          key: 'createdTime',
          minWidth: 130,
          align: 'center',
          sortable: true,
          render: (h, params) => {
            return h('div', v.$uDate.dealTime(params.row.createdTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003911'),
          key: 'month',
          minWidth: 130,
          align: 'center',
          render: (h, params) => {
            let billStage = params.row.billStage;
            let text = billStage ? billStage : '-';
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003912'),
          key: 'status',
          minWidth: 110,
          align: 'center',
          render: (h, params) => {
            let type = params.row.status;
            let text = '';
            v.costFlowStatusList.map((item) => {
              if (item.value === type) {
                text = item.title;
              }
            });
            return h('div', text);
          }
        },
      ];
      if (name === 'distributor') {
        let keyList = [
          'expenseType',
          'amount',
          'packageCode',
          'distributorName',
          'distributorMerchantId',
          'createdTime',
          'status'
        ];
        v.tableColumns = columns.filter((item) => {
          return keyList.includes(item.key);
        });
      } else {
        let keyList = [
          'expenseType',
          'amount',
          'packageCode',
          'supplierName',
          'supplierMerchantId',
          'createdTime',
          'month',
          'status'
        ];
        v.tableColumns = columns.filter((item) => {
          return keyList.includes(item.key);
        });
      }
    },
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    },
    tabName: {
      handler(name) {
        this.handleColumns(name);
      },
      deep: true,
      immediate: true
    }
  },
  components: {
    dropDownFilter
  }
};
</script>
<style lang="less" scoped>
.tabs_styles {
  /deep/ .ivu-tabs-bar {
    border-bottom: none;
    background-color: #fff;
    padding: 8px 0 3px 0;
    margin: 0;
  }
}
</style>
